const crypto = require('crypto');
const $ = require('jquery');
const JSONbig = require('json-bigint')({"storeAsString": true});

//обработка сабмита формы получения подписи
let form = document.getElementById("signature-form");
if(form) {
    form.addEventListener("submit", (event) => {
        event.preventDefault();
        //начало обработки (отключение кнопки и нотификация)
        let button = document.querySelector('#signature-form .signature-form__submit');
        let outputDiv = document.getElementById("signature-form__output-container");
        button.disabled = true;
        $(outputDiv).append(`<div class="renewed">Обновляем</div>`);
        let renewed = document.querySelector("#signature-form__output-container .renewed");
        $(renewed).fadeIn(1000, function() {

            let originalData = document.getElementById('signature-form__original-JSON').value;
            let secretKey = document.getElementById('signature-form__secretKey').value;

            //формируем объект из строки JSON
            let jsonObject;
            //попытка парсинга объекта JSON
            let jsonContainer = document.querySelector("#signature-form .signature-form__original-JSON-container");
            try {
                jsonObject = JSONbig.parse(originalData);
            } catch (e) {
                jsonContainer.classList.add("error");
                let errorContainer = document.querySelector("#signature-form .signature-form__original-JSON-error-message");
                errorContainer.innerHTML = "Данные не соответствуют формату JSON";

                let outputDiv = document.getElementById("signature-form__output-container");
                outputDiv.style.height = "0px";
                outputDiv.classList.remove("show");
                outputDiv.innerHTML = "";

                return;
            }
            //получаем значение поля подписи (null если поле отсутствует)
            let originDataSignature = getSignature(jsonObject)

            if (originDataSignature != null) {
                jsonContainer.classList.add("error");
                let errorContainer = document.querySelector("#signature-form .signature-form__original-JSON-error-message");
                errorContainer.innerHTML = "В параметрах указана подпись";

                let outputDiv = document.getElementById("signature-form__output-container");
                outputDiv.style.height = "0px";
                outputDiv.classList.remove("show");
                outputDiv.innerHTML = "";

                return;
            }

            jsonContainer.classList.remove("error");

            let fineData = jsonParser(jsonObject);

            //шифруем
            //конвертируем в HEX
            let hmacCryptoHex = crypto.createHmac('sha512', secretKey);
            hmacCryptoHex.update(fineData);
            let hmacHex = hmacCryptoHex.digest('hex');
            //конвертируем в бинарную строку
            let hmacBinary = hex2bin(hmacHex);
            //кодируем base64 строку
            let hmacCryptoBase64 = crypto.createHmac('sha512', secretKey);
            hmacCryptoBase64.update(fineData);
            let hmacBase64 = hmacCryptoBase64.digest('base64');

            if (jsonObject.general) {
                Object.assign(jsonObject.general, {signature: hmacBase64});
            } else {
                if (jsonObject.customer) {
                    Object.assign(jsonObject.customer, {signature: hmacBase64});
                } else {
                    Object.assign(jsonObject, {signature: hmacBase64});
                }
            }
            let result = `
            <h3>Преобразование данных в строку UTF-8 с сортировкой параметров по алфавиту</h3>
            <div class="signature-form__output-container-regular">${fineData}</div>
            <h3>Получение кода HMAC с использованием ключа и функции SHA-512 и с преобразованием в массив байт</h3>
            <h4>HEX-код</h4>
            <div class="signature-form__output-container-regular">${hmacHex}</div>
            <h4>Бинарный код</h4>
            <div class="signature-form__output-container-regular">${hmacBinary}</div>
            <h3>Кодирование массива байт кода HMAC с применением алгоритма Base64</h3>
            <div class="signature-form__output-container-regular">${hmacBase64}</div>
            <h3>Добавление подписи к данным</h3>
            <div class="signature-form__output-container-regular">${JSON.stringify(jsonObject)}</div>
            `;

            //завершение обработки (включение кнопки)
            $(renewed).fadeOut(1000, function() {
                button.disabled = false;
                // анимирование
                outputDiv.classList.add("show");
                outputDiv.classList.add("not-empty");
                outputDiv.innerHTML = result;
                let height = 0;
                for (let i = 0; i < outputDiv.children.length; i++) {
                    height += outputDiv.children[i].clientHeight;
                }
                outputDiv.style.height = `${height}px`;
                setTimeout(function () {
                    outputDiv.style.height = "auto";
                }, 1500)
            });
        });
    });
}

//обработка сабмита формы проверки подписи
let formCheck = document.getElementById("signature-form-check");
if(formCheck) {
    formCheck.addEventListener("submit", (event) => {
        event.preventDefault();
        //начало обработки (отключение кнопки и нотификация)
        let button = document.querySelector('#signature-form-check .signature-form__submit');
        let outputDiv = document.getElementById("signature-form__output-container-check");
        button.disabled = true;
        $(outputDiv).append(`<div class="renewed">Обновляем</div>`);
        let renewed = document.querySelector("#signature-form__output-container-check .renewed");
        $(renewed).fadeIn(1000, function(){
            let originalData = document.getElementById('signature-form__original-JSON-check').value;
            let secretKey = document.getElementById('signature-form__secretKey-check').value;

            //формируем объект из строки JSON
            let jsonObject;
            //попытка парсинга объекта JSON
            let jsonContainer = document.querySelector("#signature-form-check .signature-form__original-JSON-container");
            try {
                jsonObject = JSONbig.parse(originalData);
            } catch (e) {
                jsonContainer.classList.add("error");
                let errorContainer = document.querySelector("#signature-form-check .signature-form__original-JSON-error-message");
                errorContainer.innerHTML = "Данные не соответствуют формату JSON";

                let outputDiv = document.getElementById("signature-form__output-container-check");
                outputDiv.style.height = "0px";
                outputDiv.classList.remove("show");
                outputDiv.innerHTML = "";

                return;
            }

            //получаем значение поля подписи (null если поле отсутствует)
            let originDataSignature = getSignature(jsonObject, true);

            if (originDataSignature === null) {
                jsonContainer.classList.add("error");
                let errorContainer = document.querySelector("#signature-form-check .signature-form__original-JSON-error-message");
                errorContainer.innerHTML = "В параметрах отсутствует подпись";

                outputDiv.style.height = "0px";
                outputDiv.classList.remove("show");
                outputDiv.innerHTML = "";

                return;
            }

            jsonContainer.classList.remove("error");

            let fineData = jsonParser(jsonObject);

            //шифруем
            //конвертируем в HEX
            let hmacCryptoHex = crypto.createHmac('sha512', secretKey);
            hmacCryptoHex.update(fineData);
            let hmacHex =  hmacCryptoHex.digest('hex');
            //конвертируем в бинарную строку
            let hmacBinary = hex2bin(hmacHex);
            //кодируем base64 строку
            let hmacCryptoBase64 = crypto.createHmac('sha512', secretKey);
            hmacCryptoBase64.update(fineData);
            let hmacBase64 = hmacCryptoBase64.digest('base64');

            let sigCompare;
            if (originDataSignature === hmacBase64) {
                sigCompare = "<div class=\"signature-form__output-container-result\">Подписи совпадают</div>";
            } else {
                sigCompare = "<div class=\"signature-form__output-container-result negative\">Подписи не совпадают</div>";
            }

            let result = `
            <h3>Извлечение подписи из проверяемых данных</h3>
            <div class="signature-form__output-container-regular">${originDataSignature}</div> 
            <h3>Преобразование данных в строку UTF-8 с сортировкой параметров по алфавиту</h3>
            <div class="signature-form__output-container-regular">${fineData}</div>
            <h3>Получение кода HMAC с использованием ключа и функции SHA-512 и с преобразованием в массив байт</h3>
            <h4>HEX-код</h4>
            <div class="signature-form__output-container-regular">${hmacHex}</div>
            <h4>Бинарный код</h4>
            <div class="signature-form__output-container-regular">${hmacBinary}</div>
            <h3>Кодирование массива байт кода HMAC с применением алгоритма Base64</h3>
            <div class="signature-form__output-container-regular">${hmacBase64}</div>                    
            <h3>Сопоставление полученной подписи с проверяемой</h3>
            ${sigCompare}
            `;

            //завершение обработки (включение кнопки)
            $(renewed).fadeOut(1000, function(){
                button.disabled = false;
                // анимирование
                outputDiv.classList.add("show");
                outputDiv.classList.add("not-empty");
                outputDiv.innerHTML = result;
                let height = 0;
                for (let i = 0; i < outputDiv.children.length; i++) {
                    height += outputDiv.children[i].clientHeight;
                }
                outputDiv.style.height = `${height}px`;
                setTimeout(function () {
                    outputDiv.style.height = "auto";
                }, 1500)
            });
        });
    });
}

//преобразование hex в двоичный код
function hex2bin(hex){
    let compareList = {
        '0': '0000',
        '1': '0001',
        '2': '0010',
        '3': '0011',
        '4': '0100',
        '5': '0101',
        '6': '0110',
        '7': '0111',
        '8': '1000',
        '9': '1001',
        'a': '1010',
        'b': '1011',
        'c': '1100',
        'd': '1101',
        'e': '1110',
        'f': '1111',
        'A': '1010',
        'B': '1011',
        'C': '1100',
        'D': '1101',
        'E': '1110',
        'F': '1111'
    };

    let binary = '';
    for (let i = 0, len = hex.length; i < len; i++) {
        binary += compareList[hex[i]];
    }
    return binary;
}

//рекурсивный поиск поля signature по всему объекту с функцией удаления
function getSignature(obj, clear=false){
    let signature = null;
    Object.keys(obj).forEach((key) => {
        if(obj[key] === null){
            obj[key] = ""
        }
        if (typeof obj[key] === 'object' ) {
            let signatureBuff = getSignature(obj[key],clear)
            if(signatureBuff != null){
                signature = signatureBuff;
            }
        }
        else{
            if (key === 'signature'){
                signature = obj[key];
                if (clear){
                    delete obj[key];
                }
            }
        }
    });
    return signature;
}

//кодирование ArrayBuffer в строку base64
function arrayBufferToBase64(arrayBuffer){
    let base64 = "";
    let len = arrayBuffer.byteLength;
    for (let i = 0; i < len; i++) {
        base64 += String.fromCharCode(arrayBuffer[i]);
    }
    return btoa(base64);
}


//парсер для json
function jsonParser(obj) {
    return reducer(obj).slice(0, -1);
}
function reducer(obj, prefix = '', ignored = []) {
    const ordered = {};

    Object.keys(obj).sort().forEach((key) => {
        if (ignored.indexOf(key) === -1) {
            ordered[key] = obj[key];
        }
    });

    return Object.entries(ordered).reduce((acc, [prop, value]) => {
        if(value == null)
        {
            value = "";
        }
        if (typeof value === 'object') {
            return acc + reducer(value, prefix ? `${prefix}:${prop}` : prop, ignored);
        }
        // eslint-disable-next-line no-param-reassign
        if (typeof value === typeof true) value = value ? 1 : 0;
        return acc + (prefix ? `${prefix}:${prop}:${value};` : `${prop}:${value};`);
    }, '');
}


//форма гененрирования подписи - проверка на заполненность полей
function checkFieldsSignatureForm(){
    let keyInput = document.querySelector("#signature-form__secretKey");
    let jsonInput = document.querySelector("#signature-form__original-JSON");
    let formSubmit = document.querySelector("#signature-form .signature-form__submit");
    if(keyInput.value === "" || jsonInput.value === ""){
        formSubmit.disabled=true;
    }
    else{
        formSubmit.disabled=false;
    }
}
//форма проверки подписи - проверка на заполненность полей
function checkFieldsSignatureForm_check(){
    let keyInput = document.querySelector("#signature-form__secretKey-check");
    let jsonInput = document.querySelector("#signature-form__original-JSON-check");
    let formSubmit = document.querySelector("#signature-form-check .signature-form__submit");
    if(keyInput.value === "" || jsonInput.value === ""){
        formSubmit.disabled=true;
    }
    else{
        formSubmit.disabled=false;
    }
}

let secretKey = document.querySelector("#signature-form__secretKey");
let originalJSON = document.querySelector("#signature-form__original-JSON");
let secretKey_check = document.querySelector("#signature-form__secretKey-check");
let originalJSON_check = document.querySelector("#signature-form__original-JSON-check");
if(secretKey){
//форма гененрирования подписи - отключение кнопки отправки при отсутствии ключа
    secretKey.addEventListener("input", (event) => {
        checkFieldsSignatureForm();
    });
}
if(originalJSON){
//форма гененрирования подписи - отключение кнопки отправки при отсутствии JSON
    originalJSON.addEventListener("input", (event) => {
        checkFieldsSignatureForm();
    });
}
if(secretKey_check){
//форма проверки подписи - отключение кнопки отправки при отсутствии ключа
    secretKey_check.addEventListener("input", (event) => {
        checkFieldsSignatureForm_check();
    });
}
if(originalJSON_check){
//форма проверки подписи - отключение кнопки отправки при отсутствии JSON
    originalJSON_check.addEventListener("input", (event) => {
        checkFieldsSignatureForm_check();
    });
}